import { useMemo } from 'react';
import { useController } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import Input, { type InputProps } from '../Input';

export interface InputFiscalAmountProps extends InputProps {
  showCurrency?: boolean;
  allowNegative?: boolean;
  warning?: React.ReactNode | null;
  deps?: string[];
}

function InputFiscalAmount(props: InputFiscalAmountProps) {
  const {
    label,
    placeholder = '0,00',
    showCurrency = true,
    tooltip,
    warning,
    allowNegative = false,
    ...rest
  } = props;

  const rules = useMemo(
    () => (props.deps ? { deps: props.deps } : undefined),
    [props.deps],
  );

  const { field, fieldState } = useController({
    name: props.name,
    // NOTE: must be an empty string, otherwise the input will be uncontrolled
    defaultValue: '',
    rules,
  });
  const { onChange, onBlur, ref, name, value } = field;
  const disabled = field.disabled || rest.disabled;
  const error = disabled ? null : fieldState.error;

  return (
    <>
      <NumericFormat
        error={error ? error : false}
        valid={!error}
        {...rest}
        disabled={disabled}
        type="text"
        autoComplete="off"
        label={label}
        tooltip={tooltip}
        placeholder={placeholder}
        allowNegative={allowNegative}
        name={name}
        decimalScale={2}
        fixedDecimalScale={true}
        allowLeadingZeros={false}
        thousandSeparator="."
        decimalSeparator=","
        customInput={Input}
        value={value || ''}
        after={showCurrency ? 'DKK' : ''}
        onBlur={onBlur}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange(values.floatValue ?? null);
        }}
      />
      {warning && !error ? warning : null}
    </>
  );
}

export default InputFiscalAmount;
